<template>
    <router-link class="button-next" :to="(link)">
        <img src="~@/assets/images/button-next.png" alt="Next" title="Next">
    </router-link>
</template>

<script>
    export default {
        props: {
            link: Object
        }
    }
</script>

<style lang="scss" scoped>

    .button-next {
        img {
            width: 56px;
            height: auto;
            cursor: pointer;
        }
    }
</style>
